import Common from '../helper/Common';
export class StatisticsService {
    constructor(clientId, detailId, requestId = -1) {
        this.CLIENT_ID = clientId;
        this.DETAIL_ID = detailId;
        this.REQUEST_ID = requestId;
    }
    resetRequestId() {
        this.REQUEST_ID = -1;
    }
    get requestId() {
        return this.REQUEST_ID;
    }
    set requestId(requestId) {
        if (requestId > 0) {
            this.REQUEST_ID = requestId;
        }
        else {
            this.REQUEST_ID = -1;
            console.log('Invalid RequestId has been set for statistics service.');
        }
    }
    getStatisticsRequestId(forceANewRequest = false) {
        const data = {
            audience_details_id: this.DETAIL_ID,
            enable_notifications: forceANewRequest,
            user_host: Common.parentHost(),
            force_request: forceANewRequest
        };
        return window.App.$axios.post(`/api/audience/api/v1.0/audiencecriteria/queue/companyid/${this.CLIENT_ID}/getrequestid?api_user=${window.eInsightUserEmail}`, data);
    }
    getStatistics() {
        return window.App.$axios.get(`/api/audience/api/v1.0/audiencecriteria/queue/companyid/${this.CLIENT_ID}/request/${this.requestId}/statistics?api_user=${window.eInsightUserEmail}`);
    }
    checkStatisticsStatus() {
        const url = `/api/audience/api/v1.0/audiencecriteria/queue/companyid/${this.CLIENT_ID}/request/${this.requestId}/status?api_user=${window.eInsightUserEmail}`;
        return window.App.$axios.get(url);
    }
    cancelStatisticsRequest() {
        const data = {
            request_id: this.requestId,
            user_id: 1,
            send_notification: true
        };
        const url = `/api/audience/api/v1.0/audiencecriteria/queue/companyid/${this.CLIENT_ID}/request/${this.requestId}/cancel?api_user=${window.eInsightUserEmail}`;
        return window.App.$axios.post(url, data);
    }
    statisticsSetNotification(notifyUser) {
        const data = {
            user_host: Common.parentHost(),
            notifyUser
        };
        const url = `/api/audience/api/v1.0/audiencecriteria/queue/${this.requestId}/notification?api_user=${window.eInsightUserEmail}`;
        return window.App.$axios.post(url, data);
    }
}
//# sourceMappingURL=StaticsService.js.map